// extracted by mini-css-extract-plugin
export default {"stores":"stores_stores__lKFyi","storeLink":"stores_storeLink__V0AJu"};